import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import { toast } from "sonner";
import { getArts, getUserByDocument, updateUser } from "../lib/actions";
import { UpdateProfileModal } from "../components/modals/Modals";
import { LoaderIcon } from "../components/svg/Icons";
import Button from "../components/Button";
import "../components/creator/creator.css";
import { BuyModal } from "../components/Buy/BuyModal";
import { useAuth } from "../context/AuthContext";
import { getMediaElement } from "../components/GetMediaElement";

const Section = styled.section`
  min-height: ${(props) => `calc(100vh - ${props.theme.navHeight})`};
  width: 100vw;
  position: relative;
  background-color: ${(props) => props.theme.body};
`;

const Container = styled.div`
  width: 80%;
  min-height: 80vh;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    width: 100%;
    min-height: 100vh;
  }
`;

const Title = styled.h2`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  //   width: 80%;
  color: ${(props) => props.theme.text};
  align-self: flex-start;

  span {
    // text-transform: uppercase;
    font-family: "Akaya Telivigala", cursive;
  }
  .text-1 {
    color: blue;
  }
  .text-2 {
    font-size: 24px;
  }
  .text-tiny {
    font-size: 18px;
  }
  .text-3 {
    color: red;
  }
  .text-4 {
    color: red !important;
    font-size: 16px !important;
  }
  .small {
    font-size: 36px;
  }
  .smaller {
    font-size: 24px;
  }

  @media (max-width: 70em) {
    font-size: ${(props) => props.theme.fontxl};
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: flex-start;
  }
  @media (max-width: 40em) {
    // width: 90%;
  }
`;

const Div = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontmd};
    font-weight: 600;
    margin-bottom: 5px;
  }
  p span {
    color: orange;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    align-self: center;
    text-align: center;
  }
`;

const Div2 = styled.div`
  width: 100%;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
  gap: 20px;
  // background-color: red;

  p {
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
    margin-top: 10px;
  }
  button {
    margin: 10px 0;
    width: 100%;
    padding: 20px;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
  }
  @media (max-width: 64em) {
    width: 85%;
    flex-direction: column;
    color: red;
  }
  @media (max-width: 48em) {
    width: 100%;
    flex-direction: column;
    margin-bottom: 100px;
  }
`;
const BlockDiv = styled.div`
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 19%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  border-radius: 10px;

  .amount {
    font-size: 24px;
    font-weight: 600;
    color: black;
  }
  a {
    margin: 10px 0;

    padding: 20px;
    align-items: center;
    border-radius: 20px;
    background-color: black;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: white;
      color: black;
      border: 2px solid black;
      transition: all 0.3s ease;
    }
  }
  @media (max-width: 64em) {
    width: 85%;
  }
  @media (max-width: 48em) {
    align-self: center;
    text-align: center;
  }
`;
const TransferDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px auto;
  justify-content: center;
  align-items: center;
  background-color: lightgray;
  padding: 10px;
  // border-radius: 10px;

  a {
    border: 1px solid grey;
    padding: 10px 20px;
    border-radius: 10px;
    margin: 0 10px;
    background-color: none;

    &:hover {
      background-color: orange;
      color: white;
      transition: all 0.3s ease;
    }
  }
  @media (max-width: 48em) {
    font-size: 14px;
    align-self: center;
    text-align: center;
  }
`;

const DashboardPage = () => {
  const { user: authUser } = useAuth(); // Basic auth user
  const [userProfile, setUserProfile] = useState(null);
  const [arts, setArts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

  const handleOpenUpdate = () => {
    setIsUpdateModalOpen(true);
  };

  // Fetch user profile and arts when auth user is available
  useEffect(() => {
    const fetchUserData = async () => {
      if (!authUser?.$id) return;
      
      try {
        setLoading(true);
        
        // Fetch user profile document
        const userData = await getUserByDocument(authUser.$id);
        console.log("Fetched user data:", userData);
        setUserProfile(userData);
        
        // Fetch user's arts
        const userArts = await getArts(authUser.$id);
        setArts(userArts);
        
      } catch (error) {
        console.error("Error fetching user data:", error);
        toast.error("Failed to load user data");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [authUser?.$id]);

  const handleUpdateUser = async (updatedUser) => {
    console.log("Updating user:", updatedUser);
    try {
      await updateUser(updatedUser.userId, updatedUser);
      
      // Refetch user profile to get updated data
      const refreshedUserData = await getUserByDocument(authUser.$id);
      setUserProfile(refreshedUserData);
      
      setIsUpdateModalOpen(false);
      toast.success("Profile updated successfully!");
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update profile");
    }
  };

  // Memoize computed values to avoid recalculation on every render
  const { mintedArts, unMintedArts } = useMemo(() => {
    const minted = arts.filter(art => art.minted === true);
    const unminted = arts.filter(art => art.minted === false);
    return { mintedArts: minted, unMintedArts: unminted };
  }, [arts]);

  // Show loading state
  if (loading || !userProfile) {
    return (
      <Section id="Login">
        <Navigation />
        <Container>
          <div style={{ textAlign: 'center', padding: '2rem', margin: "auto" }}>
            <LoaderIcon width="40" />
            <p>Loading dashboard...</p>
          </div>
        </Container>
      </Section>
    );
  }

  const { 
    balance = 0, 
    reservedEth = 0, 
    name, 
    role, 
    avatar, 
    username,
  } = userProfile;

  return (
    <Section id="Login">
      <Navigation />
      <Container>
        <Div>
          <Title>
            <span>Account</span>
          </Title>
          <p>
            <Link to="/">Home</Link>
            <span> . Dashboard</span>
          </p>
        </Div>

        <div className="headerWraper">
          <div className="col1"></div>
          <div className="col2">
            <section className="artistSection">
              <div className="artistHeight">
                <img
                  src={avatar ?? "https://i.pravatar.cc/100"}
                  alt="Artist"
                />
              </div>
              <Title>
                <h3 className="text-2">{name ?? "John Doe"}</h3>
                <p
                  className="text-tiny"
                  style={{ color: "gray", marginTop: "10px" }}
                >
                  @{username ?? "johndoe"}
                </p>
              </Title>
              <div className="artistHeight"></div>
            </section>
            <section className="detailsSection">
              <div className="detailWrapper">
                <div className="HIDE">
                  <p>Created</p>
                  <h3>{arts.length}</h3>
                </div>
                <div>
                  <p>Minted</p>
                  <h3>{mintedArts.length}</h3>
                </div>
              </div>
            </section>
          </div>
        </div>

        <TransferDiv>
          <Link to="/transfer">Transfer Funds</Link>
          {balance > 0 ? (
            <Link to="/withdraw">Withdraw Funds</Link>
          ) : (
            <Link
              to=""
              onClick={(e) => {
                e.preventDefault();
                toast.warning("Insufficient Balance");
              }}
            >
              Withdraw Funds
            </Link>
          )}
          <Link 
            to="" 
            onClick={(e) => {
              e.preventDefault();
              handleOpenUpdate();
            }}
          >
            Update Profile
          </Link>
        </TransferDiv>

        {role === "admin" && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            margin: "auto"
          }}>
            <TransferDiv>
              <Link to="/manage-users">Manage Users</Link>
              <Link to="/manage-arts">Manage Arts</Link>
            </TransferDiv>
            <TransferDiv>
              <Link to="/new-clubs">Create Club</Link>
              <Link to="/manage-clubs">Manage Clubs</Link>
            </TransferDiv>
          </div>
        )}

        <Div2>
          <BlockDiv>
            <p>Balance</p>
            <p className="amount">{balance} ETH</p>
            <Link to="/fund">Fund Wallet</Link>
          </BlockDiv>
          <BlockDiv>
            <p>Minted Art</p>
            <p className="amount">{mintedArts.length}</p>
          </BlockDiv>
          <BlockDiv>
            <p>My Arts</p>
            <p className="amount">{arts.length}</p>
          </BlockDiv>
          <BlockDiv>
            <p>Mint Fee</p>
            <p className="amount">0.21 ETH</p>
          </BlockDiv>
          <BlockDiv>
            <p>Reserved Eth</p>
            <p className="amount">{reservedEth} ETH</p>
          </BlockDiv>
        </Div2>

        {isUpdateModalOpen && userProfile && (
          <UpdateProfileModal
            user={userProfile}
            onClose={() => setIsUpdateModalOpen(false)}
            onSave={handleUpdateUser}
          />
        )}

        <BuyModal mintedArts={mintedArts} />

        {unMintedArts.length > 0 && (
          <div className="artWrapper">
            <Title>
              <span className="text-2">Unminted Arts</span>
            </Title>
            <div className="artGrid">
              {unMintedArts.map((art, index) => (
                <div className="artCard" key={art.id || index}>
                  {/* Media thumbnail area */}
                  <div style={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    overflow: "hidden",
                    borderRadius: "0.5rem 0.5rem 0 0",
                    background: "#0f0f0f",
                    position: "relative",
                  }}>
                    {getMediaElement(art)}
                  </div>
                  <div className="artDetails">
                    <h4>{art.name}</h4>
                    <p>{art.description}</p>
                    <p className="text-tiny">Price: {art.price} ETH</p>
                    <Link to="/mint">
                      <Button className="mintButton" text="MINT" />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Container>
      <Footer />
    </Section>
  );
};

export default DashboardPage;
